module.exports = fox._r("images/events/newyear/snow1.png", __webpack_public_path__ + "images/events/newyear/snow1.png");


//////////////////
// WEBPACK FOOTER
// ./images/events/newyear/snow1.png
// module id = 570
// module chunks = 2